<template>
  <v-snackbar
      :color="options.color"
      :value="options.active"
      bottom
      class="nx-toast"
      :multi-line="multiLine"
  >{{ message }}
    <v-btn
        @click="dismiss()"
        dark
        flat
        v-html="$t('message.common.close')"
        v-if="options.dismissable"
    ></v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'nx-toast',
  computed: {
    ...mapState('toast', ['options']),
    message() {
      if (this.$te(this.options.message)) return this.$t(this.options.message);
      return this.options.message;
    },
    multiLine() {
      return (this.message || '').length >= 70;
    },
  },
  mounted() {
    this.overlord.service('messages').on('created', this.onMessageCreated);
  },
  methods: {
    onMessageCreated(message) {
      this.$store.dispatch('toast/CREATE', { message: message.text, color: 'success' });
    },
    dismiss() {
      this.$store.dispatch('toast/DISMISS');
    },
  },
};
</script>
